// People sign in to Search Admin with in5.app's Clerk; the server checks that sign-in (x-clerk-session).
// Admin secrets are the fallback: typed in at runtime and kept for this browser tab only.
// They must never come from VITE_ variables: those are compiled into the public bundle.
//   operator: SEARCH_BOOTSTRAP_SECRET (bootstrap, delete, list stores, every store)
//   admin:    SEARCH_PUBLISH_SECRET (change one store's settings, publish)

export type AdminKeyKind = "operator" | "admin"

const STORAGE: Record<AdminKeyKind, string> = {
	operator: "in5_admin_operator_key",
	admin: "in5_admin_store_key",
}

const listeners = new Set<() => void>()
// Set while someone is signed in with Clerk: returns a fresh short-lived session token.
let sessionToken: (() => Promise<string | null>) | null = null

function read(name: string): string {
	try {
		return sessionStorage.getItem(name) || ""
	} catch {
		return ""
	}
}

export const adminKeys = {
	get(kind: AdminKeyKind): string {
		return read(STORAGE[kind])
	},
	set(kind: AdminKeyKind, value: string) {
		try {
			if (value.trim()) sessionStorage.setItem(STORAGE[kind], value.trim())
			else sessionStorage.removeItem(STORAGE[kind])
		} catch {
			// Storage unavailable (private mode): keys simply aren't remembered.
		}
		listeners.forEach((fn) => fn())
	},
	clear() {
		adminKeys.set("operator", "")
		adminKeys.set("admin", "")
	},
	setSession(provider: (() => Promise<string | null>) | null) {
		sessionToken = provider
		listeners.forEach((fn) => fn())
	},
	signedIn(): boolean {
		return sessionToken !== null
	},
	// Everything a settings or operator request needs: the Clerk session (if signed in) and any keys.
	async authHeaders(): Promise<Record<string, string>> {
		const token = sessionToken ? await sessionToken().catch(() => null) : null
		return { ...adminKeys.headers(), ...(token ? { "x-clerk-session": token } : {}) }
	},
	subscribe(fn: () => void) {
		listeners.add(fn)
		return () => {
			listeners.delete(fn)
		}
	},
	// Headers for settings changes; the server accepts either secret.
	headers(): Record<string, string> {
		const admin = adminKeys.get("admin")
		const operator = adminKeys.get("operator")
		return {
			...(admin ? { "x-publish-secret": admin } : {}),
			...(operator ? { "x-bootstrap-secret": operator } : {}),
		}
	},
}
